export enum EventFilter {
	ADMINISTERED = 'administered',
	INVITES = 'invites',
	REGISTERED = 'registered',
}

export const DEFAULT_EVENT_FILTERS = [
	EventFilter.ADMINISTERED,
	EventFilter.INVITES,
	EventFilter.REGISTERED,
];

export const FILTER_BUTTON_ORDER = [
	EventFilter.ADMINISTERED,
	EventFilter.INVITES,
	EventFilter.REGISTERED,
];
